const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search'
const USER_AGENT = 'TracksApp'

const LOCALITY_KEYS = ['city', 'town', 'village', 'municipality', 'hamlet']
const REGION_KEYS = ['state', 'region', 'county', 'state_district']
const PLACE_NAME_KEYS = [
  'amenity',
  'building',
  'shop',
  'tourism',
  'leisure',
  'office',
  'historic',
  'road',
  'house_number',
]

function pickAddressField(address, keys) {
  if (!address) return null
  for (const key of keys) {
    if (address[key]) return address[key]
  }
  return null
}

function uniqueParts(parts) {
  const seen = new Set()
  return parts.filter((part) => {
    const normalized = part.trim().toLowerCase()
    if (!normalized || seen.has(normalized)) return false
    seen.add(normalized)
    return true
  })
}

function joinParts(parts) {
  return uniqueParts(parts.filter(Boolean)).join(', ')
}

function displayNameParts(item, from = 0, count = 2) {
  return item.display_name
    .split(',')
    .map((part) => part.trim())
    .slice(from, from + count)
}

export function formatSuggestion(item, mode = 'city') {
  const address = item.address || {}
  const locality = pickAddressField(address, LOCALITY_KEYS)
  const region = pickAddressField(address, REGION_KEYS)
  const country = address.country || null
  const placeName = item.name || pickAddressField(address, PLACE_NAME_KEYS)

  if (mode === 'place') {
    if (!locality && !region && !country) {
      const hintParts = displayNameParts(item, 0, 4)
      const cityParts = hintParts.slice(0, 3)

      return {
        city: joinParts(cityParts) || hintParts.slice(0, 2).join(', ') || item.display_name,
        hint: joinParts(hintParts) || item.display_name,
      }
    }

    const city = joinParts([locality, region, country])
    const hint = joinParts([placeName, locality, region, country])

    return {
      city: city || hint || item.display_name,
      hint: hint || city || item.display_name,
    }
  }

  if (locality || country) {
    const city = joinParts([item.name || locality, country].filter(Boolean))
    const hint =
      region && city && !city.toLowerCase().includes(region.toLowerCase()) ? region : null

    return { city: city || item.display_name, hint }
  }

  if (item.name) {
    return { city: item.name, hint: null }
  }

  const parts = displayNameParts(item, 0, 2)
  return {
    city: parts.join(', ') || item.display_name,
    hint: displayNameParts(item, 2, 2).join(', ') || null,
  }
}

export async function searchCities(query, { mode = 'city' } = {}) {
  const trimmed = query.trim()
  if (trimmed.length < 2) return []

  const params = new URLSearchParams({
    q: trimmed,
    format: 'json',
    limit: '5',
    addressdetails: '1',
    'accept-language': 'ru',
  })

  const response = await fetch(`${NOMINATIM_URL}?${params}`, {
    headers: { 'User-Agent': USER_AGENT },
  })

  if (!response.ok) {
    throw new Error('Не удалось найти город')
  }

  const results = await response.json()
  return results.map((item) => {
    const { city, hint } = formatSuggestion(item, mode)

    return {
      city,
      hint: mode === 'place' ? hint || city : hint,
      lat: Number(item.lat),
      lng: Number(item.lon),
    }
  })
}
